module.exports = __webpack_public_path__ + "img/order.d4a25391.png";